import HeroScreen from "./componets/HeroScreen/HeroScreen.jsx";
import AboutScreen from "./componets/AboutScreen/AboutScreen.jsx";
import EducationScreen from "./componets/EducationScreen/Education.jsx";
import ExperienceScreen from "./componets/ExperienceScreen/ExperienceScreen.jsx";
import TechScreen from "./componets/TechScreen/TechScreen.jsx";
import ProjectsScreen from "./componets/ProjectsScreen/ProjectsScreen.jsx";
import ContactScreen from "./componets/ContactScreen/ContactScreen.jsx";
import Footer from "./componets/Footer/Footer.jsx";

const profile = {
  name: "Nehan",
  role: "Software Engineer / Mobile Developer",
  tagline:
    "I build clean UI, fast web apps / mobile apps, and robust backend systems with modern tools.",
  location: "Sri Lanka",
  email: "nehanpavindyavidananarchchi@gmail.com",
  links: [
    { label: "GitHub", href: "https://github.com/NehanVidanaarchchi" },
    { label: "LinkedIn", href: "https://www.linkedin.com/in/nehan-vidanaarachchi-635335245/" },
    // { label: "Resume", href: "#" },
  ],
};

const aboutText = `
Frontend-focused Software Engineering undergraduate (BEng Hons, University of Westminster via IIT Sri Lanka) with 1 year of internship experience at Alchemy, Colombo. I build clean, responsive React web apps and high-performance Flutter mobile apps, integrating REST APIs and Firebase/Node.js for real-time, scalable features. I’m a detail-oriented team player who enjoys shipping user-centric products in Agile environments and solving UI + data problems fast.`.trim();

const academics = [
  {
    title: "BEng (Hons) Software Engineering (Bachelor’s Degree)",
    school: "University of Westminster (via IIT Sri Lanka)",
    range: "2021 — 2025",
  },
  {
    title: "G.C.E Advanced Level Examination",
    school: "Prince College",
    stream: "Physical Science Stream",
    range: "2020",
  },
  {
    title: "G.C.E Ordinary Level Examination",
    school: "Prince College",
    range: "2017",
  },
];
const experienceItems = [
  {
    range: "2023 — 2024",
    title: "Software Engineer Intern",
    company: "Alchemy",
    points: [
      "Contributed to Flutter mobile development, improving UI performance and widget efficiency across devices.",
      "Assisted with backend tasks using Node.js + Firebase (auth, database operations, basic architecture workflows).",
      "Built responsive, reusable React components with modern JavaScript (ES6+) to improve UI consistency across screens.",
      "Integrated REST APIs for authentication and real-time data handling in web apps."
    ],
  },
];

const tech = [
  { name: "Frontend", items: ["React", "Flutter", "React Native", "HTML/CSS"] },
  { name: "Backend", items: ["Node.js", "Python", "Firebase"] },
  { name: "Data", items: ["MongoDB", "Firestore", "Google Maps API"] },
  { name: "Tools", items: ["VS Code", "Android Studio", "Visual Studio"] },
  { name: "UI", items: ["Figma", "Responsive Design"] },
  { name: "Other", items: ["Clean Architecture", "Testing", "Arduino"] },
];

const projects = [
  {
    title: "AI Chat Bot — Flutter (Dart)",
    desc: "A basic cross-platform Flutter chat app scaffold (Dart) for building an AI chatbot experience, with a clean project structure and ready-to-extend UI.",
    tags: ["Flutter", "Dart"],
    links: [
      { label: "Code", href: "https://github.com/NehanVidanaarchchi/AI_Chat_bot.git" },
      // { label: "Live", href: "#" },
    ],
  },
  {
    title: "Heart Disease Prediction Mobile App (Flutter/ML)",
    desc: "ML-integrated app that predicts heart disease risk based on user inputs.",
    tags: ["Flutter", "TensorFlow Lite", "Python (model training)"],
    links: [
      { label: "Code", href: "https://github.com/" },
      // { label: "Live", href: "#" },
    ],
  },
  {
    title: "Smart IoT Vehicular Heat Stroke Prevention System (Arduino/Flutter)",
    desc: "IoT + mobile solution that detects high vehicle temperature and sends alerts to prevent heat strokes.",
    tags: ["Arduino", "Flutter", "Temperature Sensors", "Firebase"],
    links: [
      { label: "Code", href: "https://github.com/" },
      // { label: "Live", href: "#" },
    ],
  },
  {
    title: "Fashion Mobile App",
    desc: "Shopping app for browsing and purchasing fashion products.",
    tags: ["Flutter", "Firebase"],
    links: [
      { label: "Code", href: "https://github.com/NehanVidanaarchchi/Clothing-Shop-Mobile-App.git" },
      // { label: "Live", href: "#" },
    ],
  },
  {
    title: "E-Commerce Website",
    desc: "Built a responsive e-commerce web app with product catalog, search/filter, cart, and checkout. Integrated authentication and products/orders backend, with reusable UI components and performance-focused code.",
    tags: ["React", "Node.js", "Firebase"],
    links: [
      { label: "Code", href: "https://github.com/NehanVidanaarchchi/e-commerce.git" },
      // { label: "Live", href: "#" },
    ],
  },
];

export default function App() {
  return (
    <div className="page">
      <div className="bgGrid" aria-hidden="true" />
      <div className="scanline" aria-hidden="true" />

      <main className="container">
        
        <HeroScreen profile={profile} />
        <AboutScreen profile={profile} aboutText={aboutText} />
        <EducationScreen academic={academics} />
        <ExperienceScreen items={experienceItems} />
        <ProjectsScreen items={projects} />
        <TechScreen groups={tech} />
        <ContactScreen email={profile.email} />

        <Footer name={profile.name} location={profile.location} />
      </main>
    </div>
  );
}
